'use strict';
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function isPlainObject(value) {
    if (!value || (typeof value === "undefined" ? "undefined" : _type_of(value)) !== 'object') {
        return false;
    }
    var proto = Object.getPrototypeOf(value);
    var hasObjectPrototype = proto === null || proto === Object.prototype || Object.getPrototypeOf(proto) === null;
    if (!hasObjectPrototype) {
        return false;
    }
    return Object.prototype.toString.call(value) === '[object Object]';
}
exports.isPlainObject = isPlainObject;
